import { icons, mappings } from '~components/header/weather-icons.js'

export const weatherMixin = {
  methods: {
    getIcon(symbol) {
      if (!mappings[symbol]) {
        return null
      }

      return icons[mappings[symbol].toLowerCase()]
    },
  },
}
